import React, { useState } from "react";
import { AuthProvider } from "react-oidc-context";

const cognitoAuthConfig = {
    authority:
        "https://cognito-idp.us-east-2.amazonaws.com/us-east-2_Se0l4tYgK",
    client_id: "3ldce2kkcugotrio4fsd6cvjkr",
    redirect_uri:
        window.location.hostname === "localhost"
            ? "http://localhost:3000"
            : window.location.origin,
    response_type: "code",
    scope: "email openid phone",
};

const AuthLayer = ({ children }) => {
    return <AuthProvider {...cognitoAuthConfig}>{children}</AuthProvider>;
};

export default AuthLayer;
